import { cn } from '@/lib/utils'

// Generic status vocabulary. Cron-specific statuses (ok / stale /
// last_run_failed / never_run) and a small set of generic ones
// (healthy / warning / error / unknown) collapse to four color classes.
export type StatusPillStatus =
  | 'ok'
  | 'stale'
  | 'last_run_failed'
  | 'never_run'
  | 'healthy'
  | 'warning'
  | 'error'
  | 'unknown'

interface StatusPillProps {
  status: StatusPillStatus
  label?: string
  className?: string
}

const STYLE_BY_STATUS: Record<StatusPillStatus, { dot: string; text: string; bg: string; border: string }> = {
  ok:              { dot: 'bg-status-ok',      text: 'text-status-ok',      bg: 'bg-status-ok/10',      border: 'border-status-ok/20' },
  healthy:         { dot: 'bg-status-ok',      text: 'text-status-ok',      bg: 'bg-status-ok/10',      border: 'border-status-ok/20' },
  stale:           { dot: 'bg-status-warning', text: 'text-status-warning', bg: 'bg-status-warning/10', border: 'border-status-warning/20' },
  warning:         { dot: 'bg-status-warning', text: 'text-status-warning', bg: 'bg-status-warning/10', border: 'border-status-warning/20' },
  last_run_failed: { dot: 'bg-status-error',   text: 'text-status-error',   bg: 'bg-status-error/10',   border: 'border-status-error/20' },
  error:           { dot: 'bg-status-error',   text: 'text-status-error',   bg: 'bg-status-error/10',   border: 'border-status-error/20' },
  never_run:       { dot: 'bg-muted-foreground/40', text: 'text-muted-foreground', bg: 'bg-muted', border: 'border-border' },
  unknown:         { dot: 'bg-muted-foreground/40', text: 'text-muted-foreground', bg: 'bg-muted', border: 'border-border' },
}

export function StatusPill({ status, label, className }: StatusPillProps) {
  const style = STYLE_BY_STATUS[status]
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-xs font-medium',
        style.bg,
        style.text,
        style.border,
        className
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', style.dot)} />
      {label ?? status}
    </span>
  )
}
